import { useState } from 'react'

import {
  useFeatureDispatch,
  closeDeleteConfirm,
  useFeatureState,
  setRefreshingAfterDelete,
} from '../lib/state'
import {
  destroySingleUserDocument,
  fetchUserDocuments,
} from '../lib/userDocuments.slice'

import { useAppDispatch } from '@/utils/typeHelpers'
import { Dialog, Button } from '@/ui'

export const ConfirmDeleteDocumentDialog = () => {
  const [loading, setLoading] = useState(false)
  const featureDispatch = useFeatureDispatch()
  const dispatch = useAppDispatch()
  const { documentToDelete: document } = useFeatureState()
  const isOpen = Boolean(document)
  const closeConfirm = () => {
    featureDispatch?.(closeDeleteConfirm())
  }

  const onCancel = () => {
    if (loading) return
    closeConfirm()
  }

  const resetState = () => {
    setLoading(false)
  }

  const onConfirm = async () => {
    if (loading) return
    if (!document) return

    setLoading(true)

    // Set refreshing state to clear tables in all tabs
    featureDispatch?.(setRefreshingAfterDelete(true))

    // Delete the document
    await destroySingleUserDocument(document.id)(dispatch)

    // Close dialog
    closeConfirm()
    resetState()

    // Force refresh to clear any duplicate rows
    await dispatch(fetchUserDocuments(true, true))

    // Clear refreshing state
    featureDispatch?.(setRefreshingAfterDelete(false))
  }

  const fileDescription = document?.fileDescription || 'the selected document'
  return (
    <Dialog open={isOpen} onClose={onCancel}>
      <Dialog.Content size="sm">
        <Dialog.Title>Are you sure?</Dialog.Title>

        <Dialog.Description>
          Are you sure you want to delete {fileDescription}? Once deleted, this
          file cannot be retrieved.
        </Dialog.Description>

        <Dialog.Footer>
          <Dialog.Close asChild>
            <Button variant="secondary">Cancel</Button>
          </Dialog.Close>

          <Button variant="danger" onClick={onConfirm}>
            {loading ? 'Deleting...' : 'Delete'}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
